import Head from "next/head";
import SeoHead from "@/Component/Seo/SeoHead";
import {
  serverFetchCouponList,
  serverFetchReviewsList,
  serverFetchSeasonalDeals,
  serverFetchUnlockParadise,
} from "@/services/server";
import { getCountryFromContext } from "@/utils/getCountryFromRequest";
import { fetchPageSeo } from "@/utils/pageSeo";
import FlightHome from "@/Component/Module/FlightHome";

function setHomeCacheHeaders(res) {
  if (!res) return;
  res.setHeader(
    "Cache-Control",
    "public, s-maxage=60, stale-while-revalidate=300"
  );
}

export default function Home({
  seo,
  seoCountry,
  initialUnlockParadise,
  initialCouponList,
  initialSeasonalDeals,
  initialReviewsList,
}) {

  return (
    <>
      <Head>
        <link rel="preload" as="image" href={"/assets/images/FlightBanner.png"} fetchPriority="high" />
      </Head>
      <SeoHead
        seo={seo}
        country={seoCountry}
        fallbackTitle="Next Holidays | Your Next Journey Begins Here"
      />
      <FlightHome
        data={{
          initialUnlockParadise,
          initialCouponList,
          initialSeasonalDeals,
          initialReviewsList,
        }}
      />
    </>
  );
}

export async function getServerSideProps(context) {
  setHomeCacheHeaders(context.res);
  const country = getCountryFromContext(context);

  const [
    seoResult,
    unlockParadise,
    couponList,
    seasonalDeals,
    reviewsList
  ] = await Promise.all([
    fetchPageSeo(context, { ignoreRedirect: true }),
    serverFetchUnlockParadise(country).catch(() => null),
    serverFetchCouponList(country).catch(() => null),
    serverFetchSeasonalDeals(country).catch(() => null),
    serverFetchReviewsList({ moduleType: "Holiday" }, country).catch(() => null),
  ]);

  if (seoResult.redirect) return seoResult;

  return {
    props: {
      seo: seoResult.seo,
      seoCountry: seoResult.seoCountry,
      initialUnlockParadise: unlockParadise?.data || null,
      initialCouponList: couponList?.data || null,
      initialSeasonalDeals: Array.isArray(seasonalDeals?.data)
        ? seasonalDeals.data
        : null,
      initialReviewsList: reviewsList?.data || null,
    },
  };
}